module.exports = __webpack_public_path__ + "static/media/gcdef_10042.8a49ba97.ico";